import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "title", "content", "date", "link"]

  connect() {
    this.element.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this.close()
    })
  }

  open(event) {
    event.preventDefault()
    const data = event.currentTarget.dataset
    
    this.titleTarget.textContent = data.title
    this.contentTarget.textContent = data.content
    if (this.hasDateTarget) this.dateTarget.textContent = data.date || ""
    
    // Optional: Link handling if needed
    if (this.hasLinkTarget && data.url) {
      this.linkTarget.href = data.url
      this.linkTarget.classList.remove("hidden")
    } else if (this.hasLinkTarget) {
      this.linkTarget.classList.add("hidden")
    }

    this.dialogTarget.showModal()
    document.body.style.overflow = "hidden" // Prevent background scrolling
  }

  close(event) {
    if (event) event.preventDefault()
    this.dialogTarget.close()
    document.body.style.overflow = "" // Restore scrolling
  }

  // Close when clicking outside the modal content
  clickOutside(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }
}
